import { useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDevToolsStore } from '@frontend/devtools';
import { useAlert, useModalControl } from '@frontend/design-system';
import { useOnboardingFlowInfo } from '../../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useGetCalendarV3QueriesData } from '../../../hooks/scheduler-v3/use-get-calendar-v3-queries-data';
import { trackOnboardingFlow } from '../../../utils/track-onboarding-flow';
import { useFocusCalendarEvent } from '../use-calendar-custom-events';
import { LazyConfettiAnimation } from './lazy-confetti-animation';
import { ScheduleOnboardingFlowBookingSuccessModal } from './schedule-onboarding-flow-booking-success-modal';
import { ScheduleOnboardingFlowModal } from './schedule-onboarding-flow-modal';

export const ScheduleOnboardingFlow = () => {
  const alerts = useAlert();
  const isDebugModeOn = useDevToolsStore((state) => state.options.isDebugModeOn);
  const [isAnimating, setIsAnimating] = useState(false);
  const { resetOnboardingFlowInfo, onboardingFlowInfo } = useOnboardingFlowInfo();
  const { calendarEventsData } = useGetCalendarV3QueriesData();
  const onboardingFlowSuccessModalControls = useModalControl();

  useHotkeys(
    'shift+ctrl+c',
    () => {
      if (!isDebugModeOn) return;
      resetOnboardingFlowInfo(true);
      alerts.success('Onboarding flow has been reset.');
    },
    []
  );

  // TODO: remove once not needed
  useEffect(() => {
    if (!isDebugModeOn) return;
    console.log('Onboarding flow info:', onboardingFlowInfo);
  }, [onboardingFlowInfo]);

  useFocusCalendarEvent(calendarEventsData, () => {
    setIsAnimating(true);
    trackOnboardingFlow('firstAppointmentBooked');
  });

  // Handle new login onboarding flow reset
  useEffect(() => {
    resetOnboardingFlowInfo();
  }, []);

  return (
    <>
      <ScheduleOnboardingFlowModal />
      <ScheduleOnboardingFlowBookingSuccessModal {...onboardingFlowSuccessModalControls.modalProps} />
      <LazyConfettiAnimation
        isAnimating={isAnimating}
        onComplete={() => {
          setIsAnimating(false);
          onboardingFlowSuccessModalControls.openModal();
        }}
      />
    </>
  );
};
